import { Note, PutNoteInput, PutNoteResponse } from "../../../types/api/admin/note";
import { request } from "../../apiService";

export const getUserAdminNotes = async (userId: string) => {
    return await request<Note>(`/v2/admin/users/${userId}/notes`);
};

export const saveAdminNotes = async (userId: string, input: PutNoteInput) => {
    return await request<PutNoteResponse, PutNoteInput>(
        `/v2/admin/users/${userId}/notes`,
        {
            method: "PUT",
            input
        }
    );
};
